/* eslint-disable max-len, padded-blocks, prefer-destructuring */

export default {
  computed: {
    workorderLookupsLoading() {
      if (!this.contactBriefs || this.contactBriefs === null) return true;
      if (!this.opportunityBriefs || this.opportunityBriefs === null) return true;
      if (!this.organizationBriefs || this.organizationBriefs === null) return true;
      if (!this.products || this.products === null || this.products.length === 0) return true;
      return false;
    },
  },
  methods: {
    getBillVisible(bill) {
      /* eslint-disable-next-line */
      let visible = bill.status != this.config.workOrderBillForm.submitStatus.Paid && bill.status != this.config.workOrderBillForm.submitStatus.Voided;
      return visible;
    },
    getBillIndex(workorder, bill) {
      return workorder.workOrderBills.indexOf(bill);
    },
    getVendorContactName(workorder) {
      if (!workorder.vendorContactId) return '';
      const item = (this.contactBriefs || []).find((e) => e.id === workorder.vendorContactId);
      if (item != null) return item.name;
      return '';
    },
    getVendorOrganizationName(workorder) {
      if (!workorder.vendorOrganizationId) return '';
      const item = (this.organizationBriefs || []).find((e) => e.id === workorder.vendorOrganizationId);
      if (item != null) return item.name;
      return '';
    },
    initWorkorderEditModel(workorder) {
      const fiscalYear = this.getFiscalYear(workorder.requestedDate);
      const fiscalYearStart = new Date(`${fiscalYear - 1}`, 6, 1);
      const fiscalYearEnd = new Date(`${fiscalYear}`, 5, 30, 23, 59, 59, 999);
      const opportunityBrief = this.opportunityBriefs.find((e) => e.id === workorder.opportunityId);

      const workorderEditModel = {
        id: workorder.id,
        opportunityId: workorder.opportunityId,
        opportunityName: opportunityBrief.name,
        projectId: this.project.id,
        fiscalYear,
        fiscalYearStart,
        fiscalYearEnd,
        workorderName: workorder.workOrderName,
        workorderNumber: workorder.workOrderNumber,
        requestedDate: workorder.requestedDate,
        vendorTypes: ['Individual Contact', 'Organization'],
        vendorType: 'Individual Contact',
        vendorContacts: this.contactBriefs,
        vendorOrganizations: this.organizationBriefs,
        contractorSpecialInstructions: workorder.contractorSpecialInstructions,
        dateUpdatedUTC: workorder.dateUpdatedUTC,
        status: workorder.status,
      };

      if (workorder.vendorContactId != null) {
        workorderEditModel.vendorContactId = workorder.vendorContactId;
        workorderEditModel.vendorContact = this.contactBriefs.find((e) => e.id === workorder.vendorContactId);
      } else if (workorder.vendorOrganizationId != null) {
        workorderEditModel.vendorType = 'Organization';
        workorderEditModel.vendorOrganizationId = workorder.vendorOrganizationId;
        workorderEditModel.vendorOrganization = this.organizationBriefs.find((e) => e.id === workorder.vendorOrganizationId);
      }

      return workorderEditModel;
    },
    async loadWorkorderLookups() {
      await this.$store.dispatch('Contact/getContactBriefs');
      await this.$store.dispatch('Organization/getOrganizationBriefs');
      await this.$store.dispatch('Opportunity/getWorkorderOpportunityBriefs');
      await this.$store.dispatch('Project/fetchProducts');
    },
    onWorkorderEditClick(workorder) {
      const workorderEditModel = this.initWorkorderEditModel(workorder);
      this.projectWorkorderEditIsVisible = false;
      this.$store.dispatch('Workorder/setWorkorderEditModel', workorderEditModel).then(() => {
        this.projectWorkorderEditIsVisible = true;
      });
    },
  },
};
